export default __webpack_public_path__ + "static/media/xlsx.1e5a3e50.png";